export default () => ({
	stripeKey: 'pk_live_51HvT6VAfvxhutaE8NBLbU1FdSCiK9Gp5PBYGc39wmDCwcT1v3VWUaZvPC96p9GaEwnFM1nQbp1QwQWRHlhABxzU6008zVYELMb',
	stripeSecret: '',
	stripe: null,
	elements: null,
	paymentElement: null,
	showCheckout: false,
	ordernum: '',
	isStripe: false,
	error: '',
	coupon: '',
	couponError: '',
	form: {
		fname: "",
		lname: "",
		email: "",
		street: "",
		city: "",
		country: "UK",
		zip: "",
		shippingdiffers: false,
		shipping: {
			street: "",
			city: "",
			country: "UK",
			zip: "",
		}
	},

	async checkout() {
		console.log('checkout');
		if (this.isStripe) {
			return this.pay();
		}
		if(!this.showCheckout) {
			this.showCheckout = true
			return
		}
		if(!this.$refs.checkoutForm.reportValidity()) {
			// this.showCheckout = false
			this.step = 1;
			console.log('hi');
			return;
		} else {
			console.log('ho');
		}
		const payload = { cart: this.$store.cart.items, total: this.$store.cart.total, form: this.form, coupon: this.$store.cart.coupon}
		const req = await fetch('/shop/checkout', {
			method: "POST",
			body: JSON.stringify(payload)
		})
		const res = await req.json()
		if (res.error) {
			alert(res.error)
			this.showCheckout = false
			this.step -= 1;
			return;
		}
		this.showCheckout = false
		this.isStripe = true
		this.stripeSecret = res.intent
		this.ordernum = res.order
	    this.stripe = Stripe(this.stripeKey)
		const elements = this.stripe.elements({clientSecret: res.intent})
		window.elements = elements
		const paymentElement = elements.create('payment', {fields: {
				billingDetails: {
					address: {
						country: 'never',
						postalCode: 'never'
					}
				},
			}
		})
		paymentElement.mount('#stripe-form')
	},
	
	async applyCoupon() {
		const req = await fetch('/shop/apply-coupon', {
			method: 'POST',
			body: JSON.stringify({coupon: this.coupon, cart: this.$store.cart.items})
		})
		const res = await req.json()
		if (!res.error) {
			this.$store.cart.replaceCart(res.cart)
			this.$store.cart.coupon = this.coupon
			this.couponError = 'Discount has been added to your cart'
		} else {
			this.couponError = res.error
		}
	},
	
	async pay() {
		const confirmParams = {
			return_url: document.location.protocol + '//' + document.location.hostname + '/orders/' + this.ordernum,
			payment_method_data: {
				billing_details: {
					address: {
						country: 'UK',
						postal_code: this.form.zip
					}
				}
			}
		}
		const oldCart = this.$store.cart.items
		const oldCoupon =  this.$store.cart.coupon
		this.$store.cart.items = {}
		this.$store.cart.coupon = false
		const { error } = await this.stripe.confirmPayment({elements: window.elements, confirmParams})
		this.error = error.message
		this.$store.cart.items = oldCart
		this.$store.cart.coupon = oldCoupon
	}
})